import React from 'react';
import { Tooltip } from '@iwoca/orion';
import { FormattedMessage, useIntl } from 'react-intl';
import { intlFormatCurrency } from '@iwIntlProvider/FormattedCurrency';
import styles from './xsellTooltip.module.css';
import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import messages from './xsellTooltip.messages';

const XsellTooptip = ({
    offers
}: {
    offers?: NonNullable<GetFormalOffersResponse['data']>['formal_offers'];
}) => {
    const intl = useIntl();

    const hasFlexi12 = !!offers?.find(
        (fo) =>
            fo.product_type === 'credit_facility' && fo.duration?.amount === 365
    );
    const hasFlexi24 = !!offers?.find(
        (fo) =>
            fo.product_type === 'credit_facility' && fo.duration?.amount === 730
    );
    const hasRBL = !!offers?.find(
        (fo) => fo.product_type === 'merchant_cash_advance'
    );
    const hasInterestOnly = !!offers?.find(
        (fo) =>
            fo.product_type === 'credit_facility' &&
            (fo.interest_only_repayments || 0) > 0
    );

    return (
        <span className={styles.tooltipWrapper}>
            <Tooltip
                className={styles.tooltip}
                // @ts-expect-error
                content={
                    <div className={styles.content}>
                        <FormattedMessage {...messages.title} />
                        {hasFlexi12 && (
                            <span className={styles.row}>
                                <FormattedMessage
                                    {...messages.flexiRange}
                                    values={{
                                        months: 12,
                                        min: intlFormatCurrency({
                                            intl,
                                            value: 150
                                        }),
                                        max: intlFormatCurrency({
                                            intl,
                                            value:
                                                offers?.find(
                                                    (offer) =>
                                                        offer.product_type ===
                                                            'credit_facility' &&
                                                        offer.duration
                                                            ?.amount === 365
                                                )?.max_amount || 0
                                        })
                                    }}
                                />
                            </span>
                        )}
                        {hasFlexi24 && (
                            <span className={styles.row}>
                                <FormattedMessage
                                    {...messages.flexiRange}
                                    values={{
                                        months: 24,
                                        min: intlFormatCurrency({
                                            intl,
                                            value: 150
                                        }),
                                        max: intlFormatCurrency({
                                            intl,
                                            value:
                                                offers?.find(
                                                    (offer) =>
                                                        offer.product_type ===
                                                            'credit_facility' &&
                                                        offer.duration
                                                            ?.amount === 730
                                                )?.max_amount || 0
                                        })
                                    }}
                                />
                            </span>
                        )}
                        {hasRBL && (
                            <span className={styles.row}>
                                <FormattedMessage
                                    {...messages.rblRange}
                                    values={{
                                        min: intlFormatCurrency({
                                            intl,
                                            value: 2200
                                        }),
                                        max: intlFormatCurrency({
                                            intl,
                                            value:
                                                offers?.find(
                                                    (offer) =>
                                                        offer.product_type ===
                                                        'merchant_cash_advance'
                                                )?.max_amount || 0
                                        })
                                    }}
                                />
                            </span>
                        )}
                        {hasInterestOnly && (
                            <span className={styles.row}>
                                <FormattedMessage
                                    {...messages.interestOnlyRange}
                                    values={{
                                        min: intlFormatCurrency({
                                            intl,
                                            value: 2200
                                        }),
                                        max: intlFormatCurrency({
                                            intl,
                                            value:
                                                offers?.find(
                                                    (offer) =>
                                                        offer.product_type ===
                                                            'credit_facility' &&
                                                        (offer.interest_only_repayments ||
                                                            0) > 0
                                                )?.max_amount || 0
                                        })
                                    }}
                                />
                            </span>
                        )}
                    </div>
                }
            />
        </span>
    );
};

// eslint-disable-next-line import/no-default-export
export default XsellTooptip;
